import { Button } from '@chakra-ui/react';
import ArrowDown from 'src/assets/icons/ArrowDown';
import colors from 'src/theme/colors';
import fonts from 'src/theme/fonts';
import SimpleArrowUp from 'src/assets/icons/SimpleArrowUp';

interface FormExpanderProps {
  isExpanded: boolean;
  expandedLabel: string;
  collapsedLabel: string;
  onClick: () => void;
}

export default function FormExpander({
  isExpanded = false,
  expandedLabel,
  collapsedLabel,
  onClick,
}: FormExpanderProps) {
  return (
    <Button
      onClick={onClick}
      width="100%"
      size="lg"
      bg={colors.white}
      _hover={{ bg: colors.podcastShade100 }}
      color={colors.podcastShade600}
      fontFamily={fonts.normal}
      textShadow="none"
    >
      {isExpanded ? expandedLabel : collapsedLabel}
      {isExpanded ? (
        <SimpleArrowUp color={colors.podcastShade600} />
      ) : (
        <ArrowDown color={colors.podcastShade600} />
      )}
    </Button>
  );
}
